import React from 'react';
import { Wrench, Megaphone, Lock } from "lucide-react";

export const TemplateStats = ({ category }) => {
  if (category === 'utility') {
    return (
      <div className="border border-blue-100 rounded-lg p-4 flex items-start gap-3 mt-4">
        <Wrench className="h-5 w-5 text-blue-600 mt-0.5" />
        <div>
          <p className="font-medium text-blue-900">Utility Templates</p>
          <p className="text-sm text-blue-700 mt-1">
            For transactional messages like order updates, OTP, account alerts.
          </p>
        </div>
      </div>
    );
  }

  if (category === 'authentication') {
    return (
      <div className="bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 rounded-lg p-4 flex items-start gap-3 mt-4">
        <Lock className="h-5 w-5 text-indigo-600 mt-0.5" />
        <div>
          <p className="font-medium text-indigo-900">Authentication Templates</p>
          <p className="text-sm text-indigo-700 mt-1">
            For sending one-time passwords (OTP) for login or verification.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-purple-50 dark:bg-purple-900/20 border border-purple-100 rounded-lg p-4 flex items-start gap-3 mt-4">
      <Megaphone className="h-5 w-5 text-purple-600 mt-0.5" />
      <div>
        <p className="font-medium text-purple-900">Marketing Templates</p>
        <p className="text-sm text-purple-700 mt-1">
          For promotional messages like offers, discounts, announcements.
        </p>
      </div>
    </div>
  );
};